import * as z from "zod";

export const adminClientFeeSchema = z.object({
  id: z.union([z.number(), z.string()]),
  client_id: z.string(),

  charge_config: z
    .number({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please enter a value for Charge Config";
        }
      },
    })
    .min(1, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a value larger than or equal to 1";
        }
      },
    }),

  stripe_payment_method_config_id: z.string().nullable().optional(),

  payment_method: z
    .string({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please choose a Payment Method";
        }
      },
    })
    .min(1, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a Payment Method";
        }
      },
    }),

  currency: z
    .string({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please choose a Currency";
        }
      },
    })
    .min(1, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a Currency";
        }
      },
    }),

  above: z.coerce
    .number({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please enter a value for Above";
        }
      },
    })
    .min(0, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a value larger than or equal to zero";
        }
      },
    }),

  flat: z.coerce
    .number({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please enter Flat";
        }
      },
    })
    .min(0, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a value larger than or equal to zero";
        }
      },
    }),

  percentage: z.coerce
    .number({
      error: (issue) => {
        if (issue.input === undefined) {
          return "Please enter a Percentage";
        }
      },
    })
    .min(0, {
      error: (issue) => {
        if (issue.code === "too_small") {
          return "Please enter a value larger than or equal to zero";
        }
      },
    }),

  seller_rate: z.object({
    flat: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Flat Seller Rate";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
    percentage: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Flat Seller Rate";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
  }),

  client_buyer_rate: z.object({
    flat: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Buyer Commission Flat";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
    percentage: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Buyer Commission Percentage";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
  }),

  client_seller_rate: z.object({
    flat: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Seller Commission Flat";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
    percentage: z
      .number({
        error: (issue) => {
          if (issue.input === undefined) {
            return "Please enter a Seller Commission Percentage";
          }
        },
      })
      .min(0, {
        error: (issue) => {
          if (issue.code === "too_small") {
            return "Please enter a value larger than or equal to zero";
          }
        },
      }),
  }),
});
